module.exports = __webpack_public_path__ + "static/media/importAir.66297340.png";